import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  role: '',
  projectList: [],
  recentTransactions: [],
  isPaid: process.env.REACT_APP_UNPAID_SUBSCRIPTION_STATUS_ID,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setProjectList: (state, action) => {
      state.projectList = action.payload;
    },
    setRecentTransactions: (state, action) => {
      state.recentTransactions = action.payload;
    },
    setIsPaid: (state, action) => {
      state.isPaid = action.payload;
    },
  },
});

export const {
  setIsLoggedIn,
  setRole,
  setProjectList,
  setRecentTransactions,
  setIsPaid,
} = appSlice.actions;

export default appSlice.reducer;
